export default {
  isAdManagerInitialized: false,
  adUnits: {
    toBeInitialized: [],
  },
}
